﻿import {deepEquals, NamedValue} from "@2d-front-monorepo/core";
import {useMemo} from "react";

function getSelectedItem<TValue>(items: NamedValue<TValue>[], value: TValue): string {
	if (value == null) {
		return "";
	}

	const idx = items.findIndex(x => deepEquals(value, x.value));

	if (idx === -1) {
		return "";
	}

	return idx.toString();
}

export function useSelectedItem<TValue>(items: NamedValue<TValue>[], value: TValue): string {
	return useMemo(() => getSelectedItem(items, value), [value, items]);
}
